import "./react-select.scss";

import React, { useState, useEffect } from "react";
import classnames from "classnames";
import Select from "react-select";

const mainClass = "react-select";
const hasWindow = typeof window !== "undefined";

const getWindowWidth = () => {
  const width = hasWindow ? window.innerWidth : null;
  return width;
};

const CustomOption = ({ innerProps, children, isSelected, ...props }) => {
  return (
    <div {...innerProps} className="react-select__custom-option">
      <input
        type="checkbox"
        className="react-select__custom-option-checkbox"
        checked={isSelected}
        readOnly
      />
      {children}
    </div>
  );
};

const CustomValueContainer = ({
  cx,
  children,
  getStyles,
  innerProps,
  innerRef,
  ...props
}) => (
  <div ref={innerRef} className="react-select__value-container" {...innerProps}>
    {children}
  </div>
);
const CustomMultiValue = ({
  children,
  getStyles,
  innerProps,
  innerRef,
  ...props
}) => {
  return (
    <div ref={innerRef} className="react-select__multi-value" {...innerProps}>
      {children}
    </div>
  );
};

const ReactSelect = ({
  name,
  id,
  className,
  options,
  placeholder,
  label,
  form,
  isMulti = false,
  isClearable = true,
  field = {},
}) => {
  const [windowDimensions, setWindowDimensions] = useState(getWindowWidth());

  // useEffect(() => {
  //   if (hasWindow) {
  //     function handleResize() {
  //       setWindowDimensions(getWindowWidth());
  //     }

  //     window.addEventListener("resize", handleResize);
  //     return () => window.removeEventListener("resize", handleResize);
  //   }
  // }, [hasWindow]);

  const onChange = (option) => {
    form.setFieldValue(
      field.name,
      isMulti ? option.map((item) => item.value) : option.value
    );
  };

  const getValue = () => {
    if (options) {
      return isMulti
        ? options.filter((option) => field.value.indexOf(option.value) >= 0)
        : options.find((option) => option.value === field.value);
    } else {
      return isMulti ? [] : "";
    }
  };

  return (
    <div className={classnames(`${mainClass}__wrapper`, className)}>
      {label && (
        <label htmlFor={id} className={`${mainClass}__label`}>
          {label}
        </label>
      )}
      <div className={`${mainClass}__inner`}>
        {/* eslint-disable-next-line jsx-a11y/no-onchange */}
        <Select
          name={field.name || name}
          id={id}
          hideSelectedOptions={false}
          closeMenuOnSelect={!isMulti}
          className={`${mainClass}__select`}
          classNamePrefix={`${mainClass}`}
          placeholder={placeholder}
          isMulti={isMulti}
          isClearable={isClearable}
          options={options}
          {...field}
          components={{
            Option: CustomOption,
            ValueContainer: CustomValueContainer,
            MultiValue: CustomMultiValue,
          }}
          value={getValue()}
          onChange={onChange}
          styles={{ menuPortal: (provided) => ({ ...provided, zIndex: 5 }) }}
          // defaultMenuIsOpen={windowDimensions <= 991 ? true : false}
        />
      </div>
    </div>
  );
};

export default ReactSelect;
